import {Component, OnDestroy, OnInit} from '@angular/core';
import {
    CanvasService,
    ControlService,
    HeatingCurveService,
    IconService,
    SubtitlesService
} from "../../../core";
import {MenuType} from "../../../models";
import {Subscription} from "rxjs";

@Component({
    selector: 'heating-curve-chart',
    templateUrl: './heating-curve-chart.component.html',
    styleUrls: ['./heating-curve-chart.component.scss']
})
export class HeatingCurveChartComponent implements OnInit, OnDestroy {
    private canvasJSLoadedSubscription: Subscription;

    constructor(
        public control: ControlService,
        public heatingCurve: HeatingCurveService,
        private icon: IconService,
        private subtitles: SubtitlesService,
        public canvas: CanvasService,
    ) {
    }

    ngOnInit() {
        this.canvasJSLoadedSubscription = this.canvas.canvasJSLoaded$.subscribe(isLoaded => {
            if (isLoaded) {
                this.heatingCurve.createHeatingCurveChart();
                this.control.setOverflow();
            }
        })
    }

    ngOnDestroy() {
        this.canvasJSLoadedSubscription.unsubscribe();
        this.canvas.canvasJSLoaded.next(false);
    }

    setIcon(val: number | MenuType): string {
        if (val === null) return;
        return this.icon.setIcon(val);
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }
}